export default __webpack_public_path__ + "static/media/transparentLogoDark.9b309a8e.png";